import { Sound as CommonSound } from "common/sound";
import * as R from "ramda";
export async function loadSound(src) {
    try {
        return await CommonSound.load({
            sheetPath: src,
            sprite: spriteForHowler,
            loopNameMapper,
        });
    }
    catch (e) {
        console.error(e);
        throw e;
    }
}
const loopNameMapper = (loopName) => {
    switch (loopName) {
        case "openingBgm":
            return ["openingBgm"];
    }
};
const sprite = {
    openingBgm: [0, 6 + 28 / 30],
    openingPopup: [7 + 7 / 30, 9 + 1 / 30],
    openingEnter: [9 + 12 / 30, 11 + 12 / 30],
};
const spriteForHowler = R.map(([start, end]) => [
    Math.floor(start * 1000),
    Math.floor(end * 1000 - start * 1000),
], sprite);
//# sourceMappingURL=openingSound.js.map